// 更新
export const YH_LIFE_UPDATA = Symbol('YH_LIFE_UPDATA');
// 失败处理
export const YH_LIFE_UPDATA_FILE = Symbol('YH_LIFE_UPDATA_FILE');
